import { AxiosResponse } from 'axios';
import { instance as axios } from 'api/axios';

export class BlackListService {
  static prefix = '/SpecialList/Black';

  public static async postBlackList() {
    try {
      const url = `${BlackListService.prefix}`;
      const response: AxiosResponse<any> = await axios.get(url);

      return response.data;
    } catch (error: any) {
      throw new Error(error);
    }
  }

  public static async getBlackList() {
    try {
      const url = `${BlackListService.prefix}`;
      const response: AxiosResponse<any> = await axios.get(url);

      return response.data;
    } catch (error: any) {
      throw new Error(error);
    }
  }

  public static async postBlList(body: any) {
    try {
      const url = `${BlackListService.prefix}`;
      const response: AxiosResponse<any> = await axios.post(url, body);

      return response.data;
    } catch (error: any) {
      throw new Error(error);
    }
  }

  public static async deleteBlList(id: any) {
    try {
      const url = `${BlackListService.prefix}/?id=${id}`;
      const response: AxiosResponse<any> = await axios.delete(url);

      return response.data;
    } catch (error: any) {
      throw new Error(error);
    }
  }
}
